import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  dateConvert,
  dateConvertNewFormat,
} from "../../../../utility/dateModifier";
import ResizeListener from "../../../../utility/ResizeListener";
import { CustomButton } from "../../../components/customButton/CustomButton";
import CustomModal from "../../../components/customModal/CustomModal";
import TopHeaderComponent from "../../../components/TopHeaderComponent";
import { Add } from "../../../resources/assetsManager";
import { WHITE_COLOR } from "../../../resources/colorsManager";
import { SUCCESS } from "../../../resources/constantsManager";
import AddScheduleBody from "./AddScheduleBody";
import ScheduleContainer from "./ScheduleContainer";

function Schedulers() {
  const { enqueueSnackbar } = useSnackbar();
  const { height, width } = ResizeListener();
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [data, setData] = useState([]);
  const [renderList, setRenderList] = useState(false);

  const getAllReports = () => {
    ApiRequestGet.getAllSchedules()
      .then((res) => {
        if (res.responseCode === "OK") {
          setData(res.scheduledJobList);
        } else {
        }
      })
      .catch((err) => {});
  };

  const onClickPause = (id) => {
    ApiRequestPost.pauseScheduler(id)
      .then((res) => {
        if (res?.responseCode === "OK") {
          getAllReports();
          enqueueSnackbar(res?.responseMessage, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res?.responseMessage, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err?.message || err?.responseMessage, {
          variant: "error",
        });
      });
  };
  const onClickResume = (id) => {
    ApiRequestPost.resumeScheduler(id)
      .then((res) => {
        if (res?.responseCode === "OK") {
          getAllReports();
          enqueueSnackbar(res?.responseMessage, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res?.responseMessage, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err?.message || err?.responseMessage, {
          variant: "error",
        });
      });
  };
  const onClickDelete = (id) => {
    ApiRequestPost.deleteScheduler(id)
      .then((res) => {
        if (res?.responseCode === "OK") {
          getAllReports();
          enqueueSnackbar(res?.responseMessage, {
            variant: "success",
          });
        } else {
          enqueueSnackbar(res?.responseMessage, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err?.message || err?.responseMessage, {
          variant: "error",
        });
      });
  };

  useEffect(() => {
    getAllReports();
  }, []);
  return (
    <div style={{ height: "70%" }}>
      <TopHeaderComponent
        buttonRequired
        headerName="Report Center"
        onClickFilter={() => {
          // setOpenFilter(!openFilter);
          // filterOpened(!openFilter);
        }}
        showDownload={false}
        showFilter={false}
        showDeveloper={
          <CustomButton
            title="Add Schedule"
            styles={{
              border: "none",
              width: "100%",
              borderRadius: 6,
              minWidth: 150,
            }}
            icon={Add}
            onClick={() => {
              setShowScheduleModal(true);
            }}
          />
        }
        onClickDownload={() => {}}
        disableDownloadIcon={data?.length === 0}
      />

      <div
        style={{
          marginTop: "20px",
          height: "100%",
          backgroundColor: WHITE_COLOR,
          overflow: "auto",
          borderRadius: 10,
          minHeight: height * 0.68,
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            overflow: "scroll",
            maxHeight: height * 0.7,
            minHeight: 350,
            padding: "15px 20px",
          }}
          className="schedule-scroll"
        >
          {data && data?.length > 0 ? (
            data?.map((data, i) => (
              <ScheduleContainer
                email={data?.emailId}
                frequency={data?.frequency}
                name={data?.jobName}
                type={data?.type}
                id={i}
                createdOn={dateConvertNewFormat(data?.createdOn)}
                switchDefaultValue={
                  data?.triggerState === "NORMAL" ? true : false
                }
                onClickChange={(data) => {
                  console.log(data?.triggerState, "data?.triggerState ");
                  if (data?.triggerState === "NORMAL") {
                    onClickPause(data?.jobId);
                  } else {
                    onClickResume(data?.jobId);
                  }
                }}
                onClickDelete={(data) => {
                  onClickDelete(data?.jobId);
                }}
                data={data}
              />
            ))
          ) : (
            <>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  minHeight: height * 0.6,
                }}
              >
                <p>No Schedulers found</p>
              </div>
            </>
          )}
        </div>
      </div>

      {showScheduleModal && (
        <CustomModal
          open={showScheduleModal}
          onClose={() => {
            setShowScheduleModal(false);
          }}
        >
          <AddScheduleBody
            onClose={() => {
              setShowScheduleModal(false);
            }}
            onSuccess={() => {
              setShowScheduleModal(false);
              getAllReports();
            }}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default Schedulers;
